"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVendorType = exports.getVendorTaxonomySwitchFunc = exports.getVendorTaxonomyKeyFromVendorType = exports.getVendorTaxonomyKeyFromId = exports.getVendorTaxonomyKey = exports.getVendorTaxonomyId = exports.getRecommendedBookingWindow = void 0;
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.object.to-string.js");
var _vendorTaxonomyKeys = require("./vendorTaxonomyKeys");
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Get a function that returns a value based on a given vendor taxonomy key.
 *
 * @param vendorTaxonomyKeyMap Map that associates a vendor taxonomy key with a value of type `ReturnType`
 * @returns A function that accepts a vendor taxonomy key and returns the associated value
 * @example
 * const getVendorAnimal = getVendorTaxonomySwitchFunc({
 *   [VENUES_TAXONOMY_KEY]: 'Horse',
 *   [PHOTOGRAPHERS_TAXONOMY_KEY]: 'Zebra',
 * });
 *
 * getVendorAnimal(VENUES_TAXONOMY_KEY); // Horse
 * getVendorAnimal(PHOTOGRAPHERS_TAXONOMY_KEY); // Zebra
 * getVendorAnimal(FLORISTS_TAXONOMY_KEY); // undefined
 */
var getVendorTaxonomySwitchFunc = exports.getVendorTaxonomySwitchFunc = function getVendorTaxonomySwitchFunc(vendorTaxonomyKeyMap) {
  return function (vendorTaxonomyKey) {
    return vendorTaxonomyKeyMap[vendorTaxonomyKey];
  };
};

/**
 * Gets the vendor taxonomy key for a vendor category string.
 *
 * @param categoryString A vendor category string, which can be a taxonomy key, vendor type, or other category identifier
 * @returns The vendor taxonomy key
 * @example
 * getVendorTaxonomyKey('catering'); // wedding-catering
 * getVendorTaxonomyKey('caterer'); // wedding-catering
 * getVendorTaxonomyKey('caterers'); // wedding-catering
 * getVendorTaxonomyKey(CATERING_TAXONOMY_KEY); // wedding-catering
 */
var getVendorTaxonomyKey = exports.getVendorTaxonomyKey = function getVendorTaxonomyKey(categoryString) {
  if (_vendorTaxonomyKeys.VENDOR_TAXONOMY_KEYS.find(function (key) {
    return key === categoryString;
  })) {
    return categoryString;
  }
  switch ((categoryString || '').toLowerCase()) {
    case 'accessories':
      return _vendorTaxonomyKeys.ACCESSORIES_TAXONOMY_KEY;
    case 'accommodations':
      return _vendorTaxonomyKeys.ACCOMMODATIONS_TAXONOMY_KEY;
    case 'alterations':
      return _vendorTaxonomyKeys.ALTERATIONS_PRESERVATION_TAXONOMY_KEY;
    case 'attire':
    case 'clothing rental':
    case 'attire rentals':
      return _vendorTaxonomyKeys.CLOTHING_RENTALS_TAXONOMY_KEY;
    case 'bar services & beverages':
    case 'bar services':
    case 'bar-services':
    case 'bar_services':
      return _vendorTaxonomyKeys.BAR_SERVICES_TAXONOMY_KEY;
    case 'bridal shops':
    case 'bridal_shop':
    case 'bridal gown':
      return _vendorTaxonomyKeys.BRIDAL_SHOPS_TAXONOMY_KEY;
    case 'cakes & desserts':
    case 'cakes_desserts':
    case 'cakes-desserts':
    case 'baker':
      return _vendorTaxonomyKeys.CAKES_DESSERTS_TAXONOMY_KEY;
    case 'catering':
    case 'caterer':
    case 'caterers':
      return _vendorTaxonomyKeys.CATERING_TAXONOMY_KEY;
    case 'celebrants':
    case 'celebrant':
    case 'officiant':
      return _vendorTaxonomyKeys.CELEBRANTS_OFFICIANTS_TAXONOMY_KEY;
    case 'child care':
    case 'childcare':
    case 'childcare services':
      return _vendorTaxonomyKeys.CHILDCARE_SERVICES_TAXONOMY_KEY;
    case 'lighting':
    case 'lighting & av':
    case 'lighting-av':
      return _vendorTaxonomyKeys.LIGHTING_AV_TAXONOMY_KEY;
    case 'gift-favors':
    case 'gift & favors':
    case 'gifts':
    case 'gifts & favors':
      return _vendorTaxonomyKeys.GIFT_FAVORS_TAXONOMY_KEY;
    case 'florist':
    case 'florists':
      return _vendorTaxonomyKeys.FLORISTS_TAXONOMY_KEY;
    case 'general_services':
    case 'general services':
      return _vendorTaxonomyKeys.GENERAL_SERVICES_TAXONOMY_KEY;
    case 'beauticians':
    case 'hair-makeup':
    case 'hair':
    case 'hair & makeup':
    case 'hair_makeup':
    case 'beauty professional':
      return _vendorTaxonomyKeys.HAIR_MAKEUP_TAXONOMY_KEY;
    case 'invitations':
    case 'calligrapher':
      return _vendorTaxonomyKeys.INVITATIONS_CALLIGRAPHY_TAXONOMY_KEY;
    case 'jewelers':
    case 'jeweler':
    case 'jewelry':
      return _vendorTaxonomyKeys.JEWELERS_TAXONOMY_KEY;
    case 'musicians':
    case 'musician_dj':
    case 'bands':
    case 'bands & djs':
    case 'bands-djs':
    case 'musician':
      return _vendorTaxonomyKeys.BANDS_DJS_TAXONOMY_KEY;
    case 'photo booth':
    case 'photobooth':
      return _vendorTaxonomyKeys.PHOTOBOOTHS_TAXONOMY_KEY;
    case 'photographer':
    case 'photographers':
      return _vendorTaxonomyKeys.PHOTOGRAPHERS_TAXONOMY_KEY;
    case 'planner':
    case 'planners':
    case 'wedding planner':
      return _vendorTaxonomyKeys.PLANNERS_TAXONOMY_KEY;
    case 'tents-rentals-decor':
    case 'tents, rentals & decor':
    case 'rentals_decor':
    case 'decor':
      return _vendorTaxonomyKeys.RENTALS_DECOR_TAXONOMY_KEY;
    case 'staff':
    case 'service_staff':
    case 'service staff':
      return _vendorTaxonomyKeys.SERVICE_STAFF_TAXONOMY_KEY;
    case 'transportation':
      return _vendorTaxonomyKeys.TRANSPORTATION_PROVIDERS_TAXONOMY_KEY;
    case 'variety_act':
    case 'entertainment':
      return _vendorTaxonomyKeys.VARIETY_ACTS_TAXONOMY_KEY;
    case 'venue':
    case 'venues':
      return _vendorTaxonomyKeys.VENUES_TAXONOMY_KEY;
    case 'videographer':
    case 'videographers':
      return _vendorTaxonomyKeys.VIDEOGRAPHERS_TAXONOMY_KEY;
    default:
      return undefined;
  }
};

/**
 * Get the vendor taxonomy ID for a vendor category
 *
 * @param categoryString A vendor category string, which can be a taxonomy key, vendor type, or other category identifier
 * @returns The vendor taxonomy ID
 */
var getVendorTaxonomyId = exports.getVendorTaxonomyId = function getVendorTaxonomyId(categoryString) {
  var _getVendorTaxonomySwi;
  var vendorTaxonomyKey = getVendorTaxonomyKey(categoryString);
  if (!vendorTaxonomyKey) {
    return undefined;
  }
  return getVendorTaxonomySwitchFunc((_getVendorTaxonomySwi = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_getVendorTaxonomySwi, _vendorTaxonomyKeys.VENUES_TAXONOMY_KEY, 1), _vendorTaxonomyKeys.PHOTOGRAPHERS_TAXONOMY_KEY, 2), _vendorTaxonomyKeys.VIDEOGRAPHERS_TAXONOMY_KEY, 3), _vendorTaxonomyKeys.FLORISTS_TAXONOMY_KEY, 4), _vendorTaxonomyKeys.PHOTOBOOTHS_TAXONOMY_KEY, 5), _vendorTaxonomyKeys.TRANSPORTATION_PROVIDERS_TAXONOMY_KEY, 6), _vendorTaxonomyKeys.PLANNERS_TAXONOMY_KEY, 7), _vendorTaxonomyKeys.RENTALS_DECOR_TAXONOMY_KEY, 8), _vendorTaxonomyKeys.BANDS_DJS_TAXONOMY_KEY, 9), _vendorTaxonomyKeys.HAIR_MAKEUP_TAXONOMY_KEY, 10), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_getVendorTaxonomySwi, _vendorTaxonomyKeys.INVITATIONS_CALLIGRAPHY_TAXONOMY_KEY, 11), _vendorTaxonomyKeys.ACCESSORIES_TAXONOMY_KEY, 12), _vendorTaxonomyKeys.GIFT_FAVORS_TAXONOMY_KEY, 13), _vendorTaxonomyKeys.SERVICE_STAFF_TAXONOMY_KEY, 14), _vendorTaxonomyKeys.ALTERATIONS_PRESERVATION_TAXONOMY_KEY, 15), _vendorTaxonomyKeys.LIGHTING_AV_TAXONOMY_KEY, 16), _vendorTaxonomyKeys.CLOTHING_RENTALS_TAXONOMY_KEY, 17), _vendorTaxonomyKeys.CATERING_TAXONOMY_KEY, 18), _vendorTaxonomyKeys.CAKES_DESSERTS_TAXONOMY_KEY, 19), _vendorTaxonomyKeys.CELEBRANTS_OFFICIANTS_TAXONOMY_KEY, 20), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_getVendorTaxonomySwi, _vendorTaxonomyKeys.BRIDAL_SHOPS_TAXONOMY_KEY, 21), _vendorTaxonomyKeys.JEWELERS_TAXONOMY_KEY, 22), _vendorTaxonomyKeys.CHILDCARE_SERVICES_TAXONOMY_KEY, 23), _vendorTaxonomyKeys.VARIETY_ACTS_TAXONOMY_KEY, 24), _vendorTaxonomyKeys.GENERAL_SERVICES_TAXONOMY_KEY, 25), _vendorTaxonomyKeys.ACCOMMODATIONS_TAXONOMY_KEY, 26), _vendorTaxonomyKeys.BAR_SERVICES_TAXONOMY_KEY, 28)))(vendorTaxonomyKey);
};

/**
 * Get the vendor taxonomy key for a vendor taxonomy ID
 */
var getVendorTaxonomyKeyFromId = exports.getVendorTaxonomyKeyFromId = function getVendorTaxonomyKeyFromId(id) {
  var vendorTaxonomyKeyById = {
    1: _vendorTaxonomyKeys.VENUES_TAXONOMY_KEY,
    2: _vendorTaxonomyKeys.PHOTOGRAPHERS_TAXONOMY_KEY,
    3: _vendorTaxonomyKeys.VIDEOGRAPHERS_TAXONOMY_KEY,
    4: _vendorTaxonomyKeys.FLORISTS_TAXONOMY_KEY,
    5: _vendorTaxonomyKeys.PHOTOBOOTHS_TAXONOMY_KEY,
    6: _vendorTaxonomyKeys.TRANSPORTATION_PROVIDERS_TAXONOMY_KEY,
    7: _vendorTaxonomyKeys.PLANNERS_TAXONOMY_KEY,
    8: _vendorTaxonomyKeys.RENTALS_DECOR_TAXONOMY_KEY,
    9: _vendorTaxonomyKeys.BANDS_DJS_TAXONOMY_KEY,
    10: _vendorTaxonomyKeys.HAIR_MAKEUP_TAXONOMY_KEY,
    11: _vendorTaxonomyKeys.INVITATIONS_CALLIGRAPHY_TAXONOMY_KEY,
    12: _vendorTaxonomyKeys.ACCESSORIES_TAXONOMY_KEY,
    13: _vendorTaxonomyKeys.GIFT_FAVORS_TAXONOMY_KEY,
    14: _vendorTaxonomyKeys.SERVICE_STAFF_TAXONOMY_KEY,
    15: _vendorTaxonomyKeys.ALTERATIONS_PRESERVATION_TAXONOMY_KEY,
    16: _vendorTaxonomyKeys.LIGHTING_AV_TAXONOMY_KEY,
    17: _vendorTaxonomyKeys.CLOTHING_RENTALS_TAXONOMY_KEY,
    18: _vendorTaxonomyKeys.CATERING_TAXONOMY_KEY,
    19: _vendorTaxonomyKeys.CAKES_DESSERTS_TAXONOMY_KEY,
    20: _vendorTaxonomyKeys.CELEBRANTS_OFFICIANTS_TAXONOMY_KEY,
    21: _vendorTaxonomyKeys.BRIDAL_SHOPS_TAXONOMY_KEY,
    22: _vendorTaxonomyKeys.JEWELERS_TAXONOMY_KEY,
    23: _vendorTaxonomyKeys.CHILDCARE_SERVICES_TAXONOMY_KEY,
    24: _vendorTaxonomyKeys.VARIETY_ACTS_TAXONOMY_KEY,
    25: _vendorTaxonomyKeys.GENERAL_SERVICES_TAXONOMY_KEY,
    26: _vendorTaxonomyKeys.ACCOMMODATIONS_TAXONOMY_KEY,
    28: _vendorTaxonomyKeys.BAR_SERVICES_TAXONOMY_KEY
  };
  return vendorTaxonomyKeyById[id];
};

/**
 * Get the vendor taxonomy key for a vendor type enum string
 *
 * @param vendorType The vendor type enum used in search and booked vendors
 * @returns The vendor taxonomy key
 */
var getVendorTaxonomyKeyFromVendorType = exports.getVendorTaxonomyKeyFromVendorType = function getVendorTaxonomyKeyFromVendorType(vendorType) {
  var vendorTaxonomyKeyByVendorType = {
    ACCESSORIES: _vendorTaxonomyKeys.ACCESSORIES_TAXONOMY_KEY,
    ACCOMMODATIONS: _vendorTaxonomyKeys.ACCOMMODATIONS_TAXONOMY_KEY,
    ALTERATIONS: _vendorTaxonomyKeys.ALTERATIONS_PRESERVATION_TAXONOMY_KEY,
    ATTIRE: _vendorTaxonomyKeys.CLOTHING_RENTALS_TAXONOMY_KEY,
    BAR_SERVICES: _vendorTaxonomyKeys.BAR_SERVICES_TAXONOMY_KEY,
    BRIDAL_SHOP: _vendorTaxonomyKeys.BRIDAL_SHOPS_TAXONOMY_KEY,
    CAKES_DESSERTS: _vendorTaxonomyKeys.CAKES_DESSERTS_TAXONOMY_KEY,
    CATERER: _vendorTaxonomyKeys.CATERING_TAXONOMY_KEY,
    CELEBRANT: _vendorTaxonomyKeys.CELEBRANTS_OFFICIANTS_TAXONOMY_KEY,
    CHILDCARE: _vendorTaxonomyKeys.CHILDCARE_SERVICES_TAXONOMY_KEY,
    FLORIST: _vendorTaxonomyKeys.FLORISTS_TAXONOMY_KEY,
    GENERAL_SERVICES: _vendorTaxonomyKeys.GENERAL_SERVICES_TAXONOMY_KEY,
    GIFTS: _vendorTaxonomyKeys.GIFT_FAVORS_TAXONOMY_KEY,
    HAIR_MAKEUP: _vendorTaxonomyKeys.HAIR_MAKEUP_TAXONOMY_KEY,
    INVITATIONS: _vendorTaxonomyKeys.INVITATIONS_CALLIGRAPHY_TAXONOMY_KEY,
    JEWELER: _vendorTaxonomyKeys.JEWELERS_TAXONOMY_KEY,
    LIGHTING_AV: _vendorTaxonomyKeys.LIGHTING_AV_TAXONOMY_KEY,
    MUSICIAN_DJ: _vendorTaxonomyKeys.BANDS_DJS_TAXONOMY_KEY,
    PHOTOBOOTH: _vendorTaxonomyKeys.PHOTOBOOTHS_TAXONOMY_KEY,
    PHOTOGRAPHER: _vendorTaxonomyKeys.PHOTOGRAPHERS_TAXONOMY_KEY,
    PLANNER: _vendorTaxonomyKeys.PLANNERS_TAXONOMY_KEY,
    RENTALS_DECOR: _vendorTaxonomyKeys.RENTALS_DECOR_TAXONOMY_KEY,
    SERVICE_STAFF: _vendorTaxonomyKeys.SERVICE_STAFF_TAXONOMY_KEY,
    TRANSPORTATION: _vendorTaxonomyKeys.TRANSPORTATION_PROVIDERS_TAXONOMY_KEY,
    VARIETY_ACT: _vendorTaxonomyKeys.VARIETY_ACTS_TAXONOMY_KEY,
    VENUE: _vendorTaxonomyKeys.VENUES_TAXONOMY_KEY,
    VIDEOGRAPHER: _vendorTaxonomyKeys.VIDEOGRAPHERS_TAXONOMY_KEY
  };
  return vendorTaxonomyKeyByVendorType[vendorType];
};

/**
 * Get the vendor type for a vendor category string
 *
 * @param categoryString A vendor category string, which can be a taxonomy key, vendor type, or other category identifier
 * @returns The vendor type enum
 */
var getVendorType = exports.getVendorType = function getVendorType(categoryString) {
  var _getVendorTaxonomySwi2;
  var vendorTaxonomyKey = getVendorTaxonomyKey(categoryString);
  if (!vendorTaxonomyKey) {
    return undefined;
  }
  return getVendorTaxonomySwitchFunc((_getVendorTaxonomySwi2 = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_getVendorTaxonomySwi2, _vendorTaxonomyKeys.ACCESSORIES_TAXONOMY_KEY, 'ACCESSORIES'), _vendorTaxonomyKeys.ACCOMMODATIONS_TAXONOMY_KEY, 'ACCOMMODATIONS'), _vendorTaxonomyKeys.ALTERATIONS_PRESERVATION_TAXONOMY_KEY, 'ALTERATIONS'), _vendorTaxonomyKeys.BANDS_DJS_TAXONOMY_KEY, 'MUSICIAN_DJ'), _vendorTaxonomyKeys.BAR_SERVICES_TAXONOMY_KEY, 'BAR_SERVICES'), _vendorTaxonomyKeys.BRIDAL_SHOPS_TAXONOMY_KEY, 'BRIDAL_SHOP'), _vendorTaxonomyKeys.CAKES_DESSERTS_TAXONOMY_KEY, 'CAKES_DESSERTS'), _vendorTaxonomyKeys.CATERING_TAXONOMY_KEY, 'CATERER'), _vendorTaxonomyKeys.CELEBRANTS_OFFICIANTS_TAXONOMY_KEY, 'CELEBRANT'), _vendorTaxonomyKeys.CHILDCARE_SERVICES_TAXONOMY_KEY, 'CHILDCARE'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_getVendorTaxonomySwi2, _vendorTaxonomyKeys.CLOTHING_RENTALS_TAXONOMY_KEY, 'ATTIRE'), _vendorTaxonomyKeys.FLORISTS_TAXONOMY_KEY, 'FLORIST'), _vendorTaxonomyKeys.GENERAL_SERVICES_TAXONOMY_KEY, 'GENERAL_SERVICES'), _vendorTaxonomyKeys.GIFT_FAVORS_TAXONOMY_KEY, 'GIFTS'), _vendorTaxonomyKeys.HAIR_MAKEUP_TAXONOMY_KEY, 'HAIR_MAKEUP'), _vendorTaxonomyKeys.INVITATIONS_CALLIGRAPHY_TAXONOMY_KEY, 'INVITATIONS'), _vendorTaxonomyKeys.JEWELERS_TAXONOMY_KEY, 'JEWELER'), _vendorTaxonomyKeys.LIGHTING_AV_TAXONOMY_KEY, 'LIGHTING_AV'), _vendorTaxonomyKeys.PHOTOBOOTHS_TAXONOMY_KEY, 'PHOTOBOOTH'), _vendorTaxonomyKeys.PHOTOGRAPHERS_TAXONOMY_KEY, 'PHOTOGRAPHER'), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_getVendorTaxonomySwi2, _vendorTaxonomyKeys.PLANNERS_TAXONOMY_KEY, 'PLANNER'), _vendorTaxonomyKeys.RENTALS_DECOR_TAXONOMY_KEY, 'RENTALS_DECOR'), _vendorTaxonomyKeys.SERVICE_STAFF_TAXONOMY_KEY, 'SERVICE_STAFF'), _vendorTaxonomyKeys.TRANSPORTATION_PROVIDERS_TAXONOMY_KEY, 'TRANSPORTATION'), _vendorTaxonomyKeys.VARIETY_ACTS_TAXONOMY_KEY, 'VARIETY_ACT'), _vendorTaxonomyKeys.VENUES_TAXONOMY_KEY, 'VENUE'), _vendorTaxonomyKeys.VIDEOGRAPHERS_TAXONOMY_KEY, 'VIDEOGRAPHER')))(vendorTaxonomyKey);
};

/**
 * Get the recommended booking window for a vendor category
 *
 * @see https://docs.google.com/document/d/1jbPdCGElVDpE8WcfCneHUkolNIctHQZhE6CjuPrvPoM/edit
 */
var getRecommendedBookingWindow = exports.getRecommendedBookingWindow = function getRecommendedBookingWindow(vendorTaxonomyKey) {
  var _getVendorTaxonomySwi3;
  var threeToSixMonths = "3\u20136 months";
  var sixToNineMonths = "6\u20139 months";
  var nineToTwelveMonths = "9\u201312 months";
  var twelvePlusMonths = '12+ months';
  return getVendorTaxonomySwitchFunc((_getVendorTaxonomySwi3 = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_getVendorTaxonomySwi3, _vendorTaxonomyKeys.ACCESSORIES_TAXONOMY_KEY, threeToSixMonths), _vendorTaxonomyKeys.ACCOMMODATIONS_TAXONOMY_KEY, sixToNineMonths), _vendorTaxonomyKeys.ALTERATIONS_PRESERVATION_TAXONOMY_KEY, threeToSixMonths), _vendorTaxonomyKeys.BANDS_DJS_TAXONOMY_KEY, sixToNineMonths), _vendorTaxonomyKeys.BAR_SERVICES_TAXONOMY_KEY, nineToTwelveMonths), _vendorTaxonomyKeys.BRIDAL_SHOPS_TAXONOMY_KEY, nineToTwelveMonths), _vendorTaxonomyKeys.CAKES_DESSERTS_TAXONOMY_KEY, sixToNineMonths), _vendorTaxonomyKeys.CATERING_TAXONOMY_KEY, nineToTwelveMonths), _vendorTaxonomyKeys.CELEBRANTS_OFFICIANTS_TAXONOMY_KEY, sixToNineMonths), _vendorTaxonomyKeys.CHILDCARE_SERVICES_TAXONOMY_KEY, sixToNineMonths), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_getVendorTaxonomySwi3, _vendorTaxonomyKeys.CLOTHING_RENTALS_TAXONOMY_KEY, threeToSixMonths), _vendorTaxonomyKeys.FLORISTS_TAXONOMY_KEY, sixToNineMonths), _vendorTaxonomyKeys.GENERAL_SERVICES_TAXONOMY_KEY, sixToNineMonths), _vendorTaxonomyKeys.GIFT_FAVORS_TAXONOMY_KEY, threeToSixMonths), _vendorTaxonomyKeys.HAIR_MAKEUP_TAXONOMY_KEY, sixToNineMonths), _vendorTaxonomyKeys.INVITATIONS_CALLIGRAPHY_TAXONOMY_KEY, sixToNineMonths), _vendorTaxonomyKeys.JEWELERS_TAXONOMY_KEY, threeToSixMonths), _vendorTaxonomyKeys.LIGHTING_AV_TAXONOMY_KEY, sixToNineMonths), _vendorTaxonomyKeys.PHOTOBOOTHS_TAXONOMY_KEY, sixToNineMonths), _vendorTaxonomyKeys.PHOTOGRAPHERS_TAXONOMY_KEY, nineToTwelveMonths), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_getVendorTaxonomySwi3, _vendorTaxonomyKeys.PLANNERS_TAXONOMY_KEY, nineToTwelveMonths), _vendorTaxonomyKeys.RENTALS_DECOR_TAXONOMY_KEY, sixToNineMonths), _vendorTaxonomyKeys.SERVICE_STAFF_TAXONOMY_KEY, sixToNineMonths), _vendorTaxonomyKeys.TRANSPORTATION_PROVIDERS_TAXONOMY_KEY, sixToNineMonths), _vendorTaxonomyKeys.VARIETY_ACTS_TAXONOMY_KEY, sixToNineMonths), _vendorTaxonomyKeys.VENUES_TAXONOMY_KEY, twelvePlusMonths), _vendorTaxonomyKeys.VIDEOGRAPHERS_TAXONOMY_KEY, sixToNineMonths)))(vendorTaxonomyKey);
};